/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
import{FeatureSymbologyDrawOrder as s}from"../../enums.js";import{Technique as o}from"./Technique.js";class t extends o{constructor(){super(...arguments),this.symbologyPlane=s.FILL,this._input=null}}export{t as FeatureTechnique};
